import { useGetETSTicketSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { TICKET_VIEWS } from 'gcs-common/slices/tickets/ticketsConstants';
import { getSelectedTicketId, getTicketView } from 'gcs-common/slices/tickets/ticketsSelectors';
import { backToTicketsOverview } from 'gcs-common/slices/tickets/ticketsSlice';
import { useDispatch, useSelector } from 'react-redux';
import TicketDetails from './TicketDetails/TicketDetails';
import TicketForm from './TicketForm/TicketForm';
import TicketsOverview from './TicketsOverview/TicketsOverview';

const Tickets = () => {
  const selectedChannelId: string = useSelector(getSelectedChannelId);
  const selectedView = useSelector(getTicketView(selectedChannelId));
  const ticketId = useSelector(getSelectedTicketId(selectedChannelId));
  const ticket = useGetETSTicketSelector({ ticketId });

  const dispatch = useDispatch();

  const navigateBack = () => {
    dispatch(backToTicketsOverview({ channelId: selectedChannelId }));
  };

  switch (selectedView) {
    case TICKET_VIEWS.FORM:
      return <TicketForm channelId={selectedChannelId} onClose={navigateBack} predefinedInputChannel="chat" />;

    case TICKET_VIEWS.DETAILS:
      if (ticket) {
        return <TicketDetails onClose={navigateBack} ticket={ticket} />;
      }

      return <LoadingIndicator />;

    default:
      return <TicketsOverview />;
  }
};

export default Tickets;
